/**
 * `pages` — les pages fixes du site (base galerie, 4.1).
 */
import { z } from 'zod';
import { bilingueSchema, CHAMPS_DOCUMENT, idSchema, slugSchema, withAudit } from './commun.js';
/** Les pages que tout site de galerie possède. */
export const CLES_PAGE = ['galerie', 'contact', 'mentions', 'confidentialite', 'libre'];
export const clePageSchema = z.enum(CLES_PAGE);
export const pageSchema = withAudit(z.object({
    _id: idSchema,
    cle: clePageSchema.default('libre'),
    titre: bilingueSchema,
    slug: slugSchema,
    contenu: bilingueSchema,
    ordre: z.int().min(0).default(0),
    visibleSurLeSite: z.boolean().default(true),
}));
export const pageCreationSchema = pageSchema.omit(CHAMPS_DOCUMENT);
export const pageMiseAJourSchema = pageCreationSchema.partial();
//# sourceMappingURL=pages.js.map